import styled from 'styled-components';

export default styled.div`
  position: relative;
  height: ${props => (props.isLarge ? '3rem' : '1.6rem')};
  width: ${props => (props.isLarge ? '3rem' : '1.6rem')};

  cursor: pointer;
  
   ${props => (props.paused ? 'left: 0.25rem;' : '0')};

  svg path {
    fill: rgba(255, 255, 255, 0.8);
  }
  svg rect {
    fill: rgba(255, 255, 255, 0.8);
  }

  &:hover {
    svg path {
      fill: rgba(255, 255, 255, 1);
    }
    svg rect {
      fill: rgba(255, 255, 255, 1);
    }
  }

  ${ props => props.thisStyles}
`;
